import { render, staticRenderFns } from "./Microsite.vue?vue&type=template&id=c7124ff6&"
import script from "./Microsite.vue?vue&type=script&lang=js&"
export * from "./Microsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports